import React from "react";

function ExportActionButtons({
  handleCSV,
  handleExcel,
  handlePDF,
  handlePrint,
}) {
  return (
    <div className="d-flex gap-3 align-items-center justify-content-end flex-wrap mt-4 me-4">
      <button
        type="button"
        className="btn btn-outline-primary btn-sm p-2 d-flex align-items-center gap-2 hover-shadow"
        onClick={handleCSV}
      >
        <i className="bi bi-filetype-csv fs-5" />
        <span className="fw-semibold">Export CSV</span>
      </button>

      <button
        type="button"
        className="btn btn-outline-success btn-sm p-2 d-flex align-items-center gap-2 hover-shadow"
        onClick={handleExcel}
      >
        <i className="bi bi-file-excel fs-5" />
        <span className="fw-semibold">Export Excel</span>
      </button>

      <button
        className="btn btn-outline-secondary btn-sm p-2 d-flex align-items-center gap-2 hover-shadow"
        onClick={handlePrint}
      >
        <i className="bi bi-printer fs-5" />
        <span className="fw-semibold">Print</span>
      </button>

      <button
        className="btn btn-outline-danger btn-sm p-2 d-flex align-items-center gap-2 hover-shadow"
        onClick={handlePDF}
      >
        <i className="bi bi-filetype-pdf fs-5" />
        <span className="fw-semibold">Export PDF</span>
      </button>
    </div>
  );
}

export default ExportActionButtons;
